// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Belt_SetInt from "rescript/lib/es6/belt_SetInt.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as TailwindMerge from "tailwind-merge";
import * as JsxPPXReactSupportC from "rescript/lib/es6/jsxPPXReactSupportC.js";
import Wf_logoSvg from "./assets/wf_logo.svg";
import * as Spinner$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/Spinner.res.mjs";
import * as Trophy$LiteracyplanetClientSxEntry from "../Trophy.res.mjs";
import * as UserContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/UserContext.res.mjs";
import * as FontAwesomeIcon$LiteracyplanetClientSxEntry from "../FontAwesomeIcon.res.mjs";
import * as WordFlyersJourneys$LiteracyplanetClientSxEntry from "./WordFlyersJourneys.res.mjs";
import * as WordFlyersTrophies$LiteracyplanetClientSxEntry from "./assets/WordFlyersTrophies.res.mjs";
import * as WordFlyersIndexQuery$LiteracyplanetClientSxEntry from "./WordFlyersIndexQuery.res.mjs";
import * as WordFlyersLevelQuery$LiteracyplanetClientSxEntry from "./WordFlyersLevelQuery.res.mjs";
import * as WordFlyersBadgesStorage$LiteracyplanetClientSxEntry from "./WordFlyersBadgesStorage.res.mjs";

var logoIcon = Wf_logoSvg;

function WordFlyersIndexContainer$UnitBadge(props) {
  var awarded = props.awarded;
  var x = Math.imul(props.position, -4) + 11 | 0;
  return React.createElement("img", {
              "aria-disabled": !awarded,
              "aria-selected": props.selected,
              className: TailwindMerge.twMerge("absolute w-[60px] z-20 aria-selected:translate-x-[--x-to] aria-selected:-translate-y-56 aria-selected:scale-[800%] transition-transform aria-selected:rotate-[360deg]", awarded ? "" : "grayscale opacity-15"),
              style: Object.assign({}, {}, {
                    "--x-to": x.toString() + "rem"
                  }),
              src: "https://assets.literacyplanet.com/word_flyers/unit_badges/" + props.journeyGate + "/" + props.unitId + ".png",
              onClick: props.onClick
            });
}

var UnitBadge = {
  make: WordFlyersIndexContainer$UnitBadge
};

function WordFlyersIndexContainer$UnitTitleButton(props) {
  return React.createElement("button", {
              className: TailwindMerge.twMerge("relative inline-block h-8 w-14 cursor-pointer overflow-clip bg-[--journey-color] text-left text-white group-aria-selected:scale-105 hover:scale-105 focus-visible:scale-105", "after:absolute after:left-1/2 after:top-[42%] after:z-[1] after:-ml-[--radial-offset] after:h-[--radial-size] after:w-[--radial-size] after:rounded-full after:bg-contain after:content-[''] after:[background-image:var(--bg-radial)]"),
              style: Object.assign({}, {}, {
                    "--bg-radial": "radial-gradient(rgb(255 255 255 / .5), transparent)",
                    "--radial-size": "200px",
                    "--radial-offset": "calc(var(--radial-size) / 2)"
                  }),
              onClick: props.onClick
            }, props.first ? React.createElement("div", {
                    className: "-mt-3 pl-1 text-xs"
                  }, "Unit") : null, React.createElement("div", {
                  className: "absolute bottom-1 right-1.5 font-bold leading-none"
                }, props.unitId));
}

var UnitTitleButton = {
  make: WordFlyersIndexContainer$UnitTitleButton
};

function WordFlyersIndexContainer$ToggleButton(props) {
  var trophyView = props.trophyView;
  var toggleView = props.toggleView;
  return React.createElement("button", {
              className: TailwindMerge.twMerge("flex h-5 items-center justify-center rounded-md bg-white px-2.5 py-3.5 text-[#5494ac] shadow-md ring-1 ring-[#5494acee]", "outline-none hover:ring-[#5494ac] focus-visible:ring-2 focus-visible:ring-[#5494ac] ", "disabled:text-lpgray-400 disabled:shadow-none disabled:ring-lpgray-250"),
              disabled: !props.scoresFound,
              onClick: (function (param) {
                  Curry._1(toggleView, undefined);
                })
            }, React.createElement(FontAwesomeIcon$LiteracyplanetClientSxEntry.make, {
                  iconName: "trophy",
                  className: TailwindMerge.twMerge("h-5 transition-[width]", trophyView ? "w-0.5" : "w-5")
                }), React.createElement(FontAwesomeIcon$LiteracyplanetClientSxEntry.make, {
                  iconName: "percent",
                  className: TailwindMerge.twMerge("h-5 transition-[width]", trophyView ? "w-5" : "w-0.5")
                }));
}

var ToggleButton = {
  make: WordFlyersIndexContainer$ToggleButton
};

function WordFlyersIndexContainer$JourneyTabs(props) {
  var onMenuClick = props.onMenuClick;
  var journey = props.journey;
  return React.createElement("ul", {
              className: "flex items-end gap-2 leading-none"
            }, Belt_Array.map(props.journeys, (function (j) {
                    return React.createElement("li", {
                                key: j.id,
                                "aria-selected": journey === j.id,
                                className: TailwindMerge.twMerge("group rounded-t-[0.22rem] bg-[#ffdbb6] text-[#a27c62]", "aria-selected:bg-[#ffefd7] aria-selected:text-[#6e4029] aria-[selected=false]:bg-gradient-to-t aria-[selected=false]:from-[#f4d5b7] aria-[selected=false]:to-[#ffefd7] aria-[selected=false]:to-20% ")
                              }, React.createElement("button", {
                                    className: "block h-full w-full rounded-t-[0.22rem] py-2 pl-4 pr-8 font-black outline-[#a27c62] group-aria-selected:pointer-events-none group-aria-selected:py-3 hover:text-[#6e4029]",
                                    onClick: (function (param) {
                                        Curry._2(onMenuClick, j.id, "1");
                                      })
                                  }, j.title));
                  })));
}

var JourneyTabs = {
  make: WordFlyersIndexContainer$JourneyTabs
};

function WordFlyersIndexContainer$ActivityButton(props) {
  var activity = props.activity;
  var partial = activity.result.started;
  var match = activity.result.bestResponsesScore;
  var bgCss = partial ? "bg-lpgray-400 text-xs after:hidden" : (
      match !== undefined ? (
          match < 80 ? "bg-[#f65640] border-[#b63b2a]" : "bg-[#46b800] border-[#389200]"
        ) : ""
    );
  var match$1 = activity.result.started;
  var match$2 = activity.result.bestResponsesScore;
  return React.createElement("button", {
              className: TailwindMerge.twMerge("relative block h-8 w-14 cursor-pointer overflow-clip border border-slate-400 bg-[#4497b5] text-white outline-none transition-transform duration-75 hover:scale-105 focus-visible:ring-1 focus-visible:ring-lpblue-700", "after:absolute after:left-1/2 after:top-[42%] after:z-[1] after:-ml-[--radial-offset] after:h-[--radial-size] after:w-[--radial-size] after:rounded-full after:bg-contain after:content-[''] after:[background-image:var(--bg-radial)]", bgCss),
              style: Object.assign({}, {}, {
                    "--bg-radial": "radial-gradient(rgb(255 255 255 / .5), transparent)",
                    "--radial-size": "200px",
                    "--radial-offset": "calc(var(--radial-size) / 2)"
                  }),
              title: activity.title,
              onClick: props.onActivityClick
            }, React.createElement("div", {
                  className: "flex h-full w-full items-center justify-center px-1.5 py-0.5"
                }, match$1 ? React.createElement("div", {
                        className: "text-center leading-none"
                      }, "in progress") : (
                    match$2 !== undefined ? (
                        props.trophyView ? React.createElement("div", {
                                className: "z-10 w-7"
                              }, WordFlyersTrophies$LiteracyplanetClientSxEntry.trophyToIcon(Trophy$LiteracyplanetClientSxEntry.scoreToTrophy(match$2))) : React.createElement("div", {
                                className: "z-10 font-sans-museo text-lg font-black [-webkit-text-stroke:1px_rgb(0_0_0_/_.75)]"
                              }, match$2.toString() + "%")
                      ) : null
                  ), React.createElement("span", {
                      className: "hidden"
                    }, activity.title)));
}

var ActivityButton = {
  make: WordFlyersIndexContainer$ActivityButton
};

function WordFlyersIndexContainer$GateTabs(props) {
  var onMenuClick = props.onMenuClick;
  var journey = props.journey;
  var gate = props.gate;
  return React.createElement("ul", {
              className: "flex items-end gap-2 leading-none"
            }, Belt_Array.mapWithIndex(props.gates, (function (idx, g) {
                    return Belt_Option.mapWithDefault(Caml_option.undefined_to_opt(g.title.split("/").pop()), null, (function (title) {
                                  return React.createElement("li", {
                                              key: g.id,
                                              "aria-selected": idx.toString() === gate,
                                              className: TailwindMerge.twMerge("group relative rounded-t-[.22rem] border-[#f0f1f3] text-[#5494ac] shadow-md  shadow-black/20", "after:absolute after:bottom-[-1px] after:z-[1] after:block after:w-full after:border-white after:content-['']", "aria-selected:bg-white aria-selected:text-[#405067] aria-selected:after:border-b aria-[selected=false]:bg-gradient-to-t aria-[selected=false]:from-[#edf1f1] aria-[selected=false]:to-white aria-[selected=false]:to-20%")
                                            }, React.createElement("button", {
                                                  className: "block h-full w-full rounded-t-[0.22rem] px-4 py-3 font-black outline-none group-aria-selected:pointer-events-none group-aria-selected:py-4 hover:text-[#405067] hover:ring-1 hover:ring-[#5494ac] focus-visible:ring-2 focus-visible:ring-[#5494ac]",
                                                  onClick: (function (param) {
                                                      Curry._2(onMenuClick, Caml_option.some(journey), String(idx));
                                                    })
                                                }, title));
                                }));
                  })));
}

var GateTabs = {
  make: WordFlyersIndexContainer$GateTabs
};

function WordFlyersIndexContainer$LessonTypePanel(props) {
  var normalise = function (title) {
    if (title === "Spelling") {
      return "Vocabulary/Spelling";
    } else {
      return title;
    }
  };
  return React.createElement("div", {
              className: "mr-2 flex flex-col justify-center gap-1.5 border border-[#c1e1ea]"
            }, React.createElement("div", {
                  className: "h-8 bg-[#c6e3eb] px-3 pt-1 text-center font-bold uppercase text-[#506682]"
                }, "Arrivals/Departures"), Belt_Array.map(props.unit.activities, (function (u) {
                    return React.createElement("div", {
                                key: u.id,
                                className: "relative h-8 px-3 pr-6 pt-1 text-[#5494ac] after:absolute after:bottom-[-0.1875rem] after:left-[2.5%] after:z-[1] after:block after:w-[95%] after:border-b after:border-[#c1e1ea]/50 after:content-[''] after:last:border-transparent"
                              }, normalise(u.title));
                  })));
}

var LessonTypePanel = {
  make: WordFlyersIndexContainer$LessonTypePanel
};

function WordFlyersIndexContainer$EmptyGrid(props) {
  return React.createElement("div", {
              className: "flex gap-2 p-2"
            });
}

var EmptyGrid = {
  make: WordFlyersIndexContainer$EmptyGrid
};

function WordFlyersIndexContainer$MetaPanel(props) {
  var meta = props.meta;
  var focusRef = React.useRef(null);
  var focusElement = function (param) {
    Belt_Option.forEach(Caml_option.nullable_to_opt(focusRef.current), (function (input) {
            input.classList.remove("rotate-90");
          }));
  };
  React.useEffect((function (param) {
          focusElement();
        }), []);
  React.useLayoutEffect((function (param) {
          Belt_Option.forEach(Caml_option.nullable_to_opt(focusRef.current), (function (input) {
                  input.focus();
                }));
        }), []);
  return React.createElement("div", {
              className: "h-full flex-col rounded-md border border-[--journey-color] bg-white"
            }, React.createElement("div", {
                  className: "flex flex-col gap-0.5 bg-[--journey-color] p-2 text-sm text-white"
                }, React.createElement("div", {
                      className: "text-lg font-black"
                    }, meta.unit, React.createElement("div", {
                          className: "float-end"
                        }, React.createElement("button", {
                              ref: Caml_option.some(focusRef),
                              className: "h-6 w-6 rotate-90 rounded-md outline-none ring-white transition-transform hover:ring-1 focus:ring-1 focus-visible:ring-2",
                              tabIndex: 0,
                              onClick: props.onClose
                            }, React.createElement(FontAwesomeIcon$LiteracyplanetClientSxEntry.make, {
                                  iconName: "xmark",
                                  prefix: "far",
                                  size: "sm",
                                  className: "h-6 w-6"
                                })))), React.createElement("div", undefined, React.createElement("span", {
                          className: "font-bold"
                        }, "Text: "), React.createElement("span", undefined, meta.title)), React.createElement("div", undefined, React.createElement("span", {
                          className: "font-bold"
                        }, "Text type: "), React.createElement("span", undefined, meta.textType)), React.createElement("div", undefined, React.createElement("span", {
                          className: "font-bold"
                        }, "About: "), React.createElement("span", undefined, meta.about))), React.createElement("div", {
                  className: "p-2"
                }, React.createElement("img", {
                      alt: "Thumbnail of unit text",
                      src: "https://assets.literacyplanet.com" + meta.thumbnail
                    })));
}

var MetaPanel = {
  make: WordFlyersIndexContainer$MetaPanel
};

function WordFlyersIndexContainer$Grid(props) {
  var setSelectedBadge = props.setSelectedBadge;
  var selectedBadge = props.selectedBadge;
  var trophyView = props.trophyView;
  var onActivityClick = props.onActivityClick;
  var units = props.units;
  var journeyGate = props.journeyGate;
  var match = React.useState(function (param) {
        
      });
  var setOpenMeta = match[1];
  var openMeta = match[0];
  var onCloseMeta = function (param) {
    Curry._1(setOpenMeta, (function (param) {
            
          }));
  };
  var cleanGate = function (param) {
    Curry._1(setOpenMeta, (function (param) {
            
          }));
    Curry._1(setSelectedBadge, (function (param) {
            
          }));
  };
  var match$1 = WordFlyersBadgesStorage$LiteracyplanetClientSxEntry.use(journeyGate, units);
  var claimedBadge = match$1[1];
  var badges = match$1[0];
  React.useEffect((function (param) {
          Curry._1(setOpenMeta, (function (param) {
                  
                }));
          Curry._1(setSelectedBadge, (function (param) {
                  
                }));
          return cleanGate;
        }), []);
  React.useEffect((function (param) {
          Curry._1(setSelectedBadge, (function (param) {
                  return claimedBadge;
                }));
        }), [claimedBadge]);
  return React.createElement("div", {
              className: "flex gap-2 p-2"
            }, React.createElement("div", {
                  className: "w-[15rem]"
                }, openMeta !== undefined ? JsxPPXReactSupportC.createElementWithKey(journeyGate + "_" + openMeta.unit, WordFlyersIndexContainer$MetaPanel, {
                        meta: openMeta,
                        onClose: onCloseMeta
                      }) : Belt_Option.mapWithDefault(Belt_Array.get(units, 0), null, (function (unit_) {
                          return React.createElement(WordFlyersIndexContainer$LessonTypePanel, {
                                      unit: unit_
                                    });
                        }))), Belt_Array.mapWithIndex(units, (function (idx, param) {
                    var meta = param.meta;
                    var unit_ = param.unit;
                    var unitId = (idx + 1 | 0).toString();
                    var badgeId = idx + 1 | 0;
                    var awarded = Belt_SetInt.has(badges, badgeId);
                    var selected = Belt_Option.mapWithDefault(selectedBadge, false, (function (bdgIdx) {
                            return bdgIdx === badgeId;
                          }));
                    var onClick = awarded ? (
                        selected ? (function (_evt) {
                              Curry._1(setSelectedBadge, (function (param) {
                                      
                                    }));
                            }) : (function (_evt) {
                              Curry._1(setSelectedBadge, (function (param) {
                                      return badgeId;
                                    }));
                            })
                      ) : undefined;
                    return React.createElement("ul", {
                                key: unit_.id,
                                "aria-selected": Belt_Option.mapWithDefault(openMeta, false, (function (m) {
                                        return m.idx === idx;
                                      })),
                                className: "group flex flex-col gap-1.5 aria-selected:text-2xl"
                              }, React.createElement("li", {
                                    className: "leading-[0]"
                                  }, React.createElement(WordFlyersIndexContainer$UnitTitleButton, {
                                        unitId: unitId,
                                        onClick: (function (param) {
                                            Curry._1(setOpenMeta, (function (m) {
                                                    if (Caml_obj.equal(m, meta)) {
                                                      return ;
                                                    } else {
                                                      return meta;
                                                    }
                                                  }));
                                          }),
                                        first: idx === 0
                                      })), Belt_Array.mapWithIndex(param.activities, (function (actIdx, activity) {
                                      return React.createElement("li", {
                                                  key: activity.id
                                                }, React.createElement(WordFlyersIndexContainer$ActivityButton, {
                                                      activity: activity,
                                                      onActivityClick: (function (param) {
                                                          Curry._2(onActivityClick, activity.id, activity.title);
                                                        }),
                                                      trophyView: trophyView
                                                    }));
                                    })), React.createElement("li", {
                                    className: "relative block h-8 w-14"
                                  }, JsxPPXReactSupportC.createElementWithKey("badge_" + unit_.id, WordFlyersIndexContainer$UnitBadge, {
                                        onClick: onClick,
                                        selected: selected,
                                        awarded: awarded,
                                        journeyGate: journeyGate,
                                        unitId: unitId,
                                        position: badgeId
                                      })));
                  })));
}

var Grid = {
  make: WordFlyersIndexContainer$Grid
};

function WordFlyersIndexContainer$Main(props) {
  var onMenuClick = props.onMenuClick;
  var onActivityClick = props.onActivityClick;
  var gate = props.gate;
  var journey = props.journey;
  var match = React.useState(function (param) {
        
      });
  var setData = match[1];
  var data = match[0];
  var match$1 = React.useState(function (param) {
        
      });
  var setSelectedBadge = match$1[1];
  var selectedBadge = match$1[0];
  var useIndex = WordFlyersIndexQuery$LiteracyplanetClientSxEntry.use();
  var match$2 = React.useState(function (param) {
        return true;
      });
  var setView = match$2[1];
  var trophyView = match$2[0];
  var toggleView = function (param) {
    Curry._1(setView, (function (x) {
            return !x;
          }));
  };
  React.useEffect((function (param) {
          var fetchIndex = async function (param) {
            var res = await Curry._2(useIndex, journey, gate);
            return Curry._1(setData, (function (param) {
                          return res;
                        }));
          };
          fetchIndex();
        }), [
        journey,
        gate
      ]);
  var tmp;
  if (data !== undefined) {
    var journeyGate = data.journeyGate;
    var grid = data.grid;
    tmp = React.createElement(React.Fragment, {}, React.createElement("nav", {
              className: "flex justify-between"
            }, React.createElement(WordFlyersIndexContainer$GateTabs, {
                  gates: data.gates,
                  gate: gate,
                  journey: journey,
                  onMenuClick: onMenuClick
                }), React.createElement("div", {
                  className: "flex items-center gap-0.5"
                }, React.createElement(WordFlyersIndexContainer$ToggleButton, {
                      toggleView: toggleView,
                      trophyView: trophyView,
                      scoresFound: grid.scoresFound
                    }))), React.createElement("section", {
              className: "relative w-full border border-[#f0f1f3] bg-white shadow-md shadow-black/20"
            }, JsxPPXReactSupportC.createElementWithKey(journeyGate, WordFlyersIndexContainer$Grid, {
                  journeyGate: journeyGate,
                  units: grid.units,
                  onActivityClick: (function (id, title) {
                      Curry._4(onActivityClick, journey, gate, id, title);
                    }),
                  onMenuClick: onMenuClick,
                  trophyView: trophyView,
                  selectedBadge: selectedBadge,
                  setSelectedBadge: setSelectedBadge
                })));
  } else {
    tmp = React.createElement("div", {
          className: "h-24 w-full pt-5"
        }, React.createElement(Spinner$LiteracyplanetClientFlags.make, {}));
  }
  return React.createElement("div", {
              style: Object.assign({}, {}, {
                    "--journey-color": WordFlyersJourneys$LiteracyplanetClientSxEntry.journeyToColor(journey)
                  })
            }, React.createElement("div", {
                  className: TailwindMerge.twMerge(Belt_Option.isSome(selectedBadge) ? "fixed inset-0 z-10" : ""),
                  onClick: (function (evt) {
                      Curry._1(setSelectedBadge, (function (param) {
                              
                            }));
                      evt.stopPropagation();
                    })
                }), React.createElement("a", {
                  className: "float-left inline-block rounded-r-full border-b border-r border-[#f0f1f3] bg-[#ffefd7] py-1.5 pl-2 pr-3 font-sans shadow-md",
                  title: "Go Back to Missions",
                  href: "#",
                  onClick: props.onBack
                }, React.createElement("svg", {
                      className: "w-6 fill-[#5494ac]",
                      id: "meteor-icon-kit__regular-chevron-left-xs",
                      viewBox: "-2 0 10 10",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          clipRule: "evenodd",
                          d: "M5.7071 8.2929C6.0976 8.6834 6.0976 9.3166 5.7071 9.7071C5.3166 10.0976 4.6834 10.0976 4.2929 9.7071L0.29289 5.7071C-0.09763 5.3166 -0.09763 4.6834 0.29289 4.2929L4.2929 0.29289C4.6834 -0.09763 5.3166 -0.09763 5.7071 0.29289C6.0976 0.68342 6.0976 1.31658 5.7071 1.70711L2.4142 5L5.7071 8.2929z",
                          fillRule: "evenodd"
                        }))), React.createElement("div", {
                  className: "m-auto grid justify-center pt-6 font-sans"
                }, React.createElement("img", {
                      className: "w-20",
                      title: "Word Flyers Logo",
                      src: logoIcon
                    }), React.createElement("div", {
                      className: "min-w-[51rem]"
                    }, React.createElement("header", undefined, React.createElement(WordFlyersIndexContainer$JourneyTabs, {
                              journeys: WordFlyersJourneys$LiteracyplanetClientSxEntry.t,
                              journey: journey,
                              onMenuClick: onMenuClick
                            })), React.createElement("div", {
                          className: "grid rounded-tr-lg bg-[#ffefd7] p-3"
                        }, tmp))));
}

var Main = {
  make: WordFlyersIndexContainer$Main
};

function WordFlyersIndexContainer(props) {
  var user = UserContext$LiteracyplanetClientFlags.use();
  var wfLevel = WordFlyersLevelQuery$LiteracyplanetClientSxEntry.use(user.userId);
  React.useEffect((function (param) {
          var r = document.querySelector(":root");
          r.style.setProperty("--html-font-size", "18px");
          return (function (param) {
                    r.removeAttribute("style");
                  });
        }), []);
  if (wfLevel === undefined) {
    return null;
  }
  var journey = Belt_Option.getWithDefault(props.optionalJourney, wfLevel.journey);
  var gate = Belt_Option.getWithDefault(props.optionalGate, wfLevel.gate);
  return React.createElement(WordFlyersIndexContainer$Main, {
              journey: journey,
              gate: gate,
              onBack: props.onBack,
              onActivityClick: props.onActivityClick,
              onMenuClick: props.onMenuClick
            });
}

var make = WordFlyersIndexContainer;

export {
  logoIcon ,
  UnitBadge ,
  UnitTitleButton ,
  ToggleButton ,
  JourneyTabs ,
  ActivityButton ,
  GateTabs ,
  LessonTypePanel ,
  EmptyGrid ,
  MetaPanel ,
  Grid ,
  Main ,
  make ,
}
/* logoIcon Not a pure module */
